<template>
  <div class="modal modal-fullscreen" tabindex="-1">
    <div class="modal-backdrop"></div>
    <div class="modal-dialog modal-dialog-centered modal-fullscreen">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title">
            <slot name="header">
            </slot>
          </div>
        </div>
        <div class="modal-body">
            <slot name="body">
            </slot>
        </div>
        <div class="modal-footer d-flex justify-content-end">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ORecepient',
  data: function(){
    return {
      action: false,
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    save() {
      this.$emit('save');
    },
  },
};
</script>

<style scoped>
.modal-fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
}

.modal-fullscreen .modal-dialog {
  position: relative;
  width: 90%;
  max-width: none;
  height: 90%;
  margin: 0;
  z-index: 1050;
}

.modal-fullscreen .modal-content {
  height: 100%;
  background-color: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
}

.modal-fullscreen .modal-body {
  overflow-y: auto;
}

.modal-header {
  border-bottom: 1px solid #dee2e6;
  padding: 1rem;
}

.modal-footer {
  border-top: 1px solid #dee2e6;
  padding: 1rem;
}

.close {
  position: absolute;
  right: 1rem;
  top: 1rem;
  font-size: 1.5rem;
  font-weight: 700;
  color: #000;
  opacity: 0.5;
  background: none;
  border: none;
  cursor: pointer;
}

.close:hover {
  opacity: 1;
}
</style>